import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';

import {StepTypeConfigUISchemaV2} from '../step-config-settings/StepConfigUISchemas';
import {FIELD_ORDER_UI_SCHEMA_KEY} from '../StepConfigEditorTypes';

export const JSON_TO_ROWS_V0_UI_SCHEMA: StepTypeConfigUISchemaV2<PipelineStepType.JSON_TO_ROWS, 0> = {
  [FIELD_ORDER_UI_SCHEMA_KEY]: ['jsonColumn', 'valueKey'],
  jsonColumn: {
    displayName: 'JSON column',
    infoText:
      'The column holding a JSON object per row to explode into columns. Defaults to the first JSON column.',
    configShapePath: ['jsonColumn'],
  },
  valueKey: {
    displayName: 'Unwrap value key',
    infoText:
      'Optional. Unwraps a single-valued envelope so each cell shaped {key: x} becomes x. Use "value" for Benchling schema fields ({"value": x}).',
    configShapePath: ['valueKey'],
  },
};
